export const mapInternalStateToPayload = state => {
  const { questions, scoreable, title } = state

  return {
    questions,
    scoreable,
    title,
  }
}
